import React from 'react'

import {
  DeleteOutlined
} from '@ant-design/icons'
import UploadButton from '../../upload/buttonV2'

import { Table, Space, Button, Divider, Popconfirm, List, Avatar } from 'antd'

const Tasks = (props) => {
  const expandedRowRender = (record) => {
    return (
      <List
        itemLayout='horizontal'
        dataSource={record.timeline || []}
        renderItem={(item) => (
          <List.Item
            key={item.id}
            actions={[
              <Popconfirm
                key='delete'
                title='Are you sure?'
                onConfirm={() => props.removeLqaComment({ qaId: record.id, commentId: item.id })}
                okText='Yes'
                cancelText='No'
                disabled={props.actionLoading}
              >
                <Button size='small'>
                  <DeleteOutlined disabled={props.actionLoading} /> Delete
                </Button>
              </Popconfirm>
            ]}
          >
            <List.Item.Meta avatar={<Avatar>U</Avatar>} title={item.person} description={item.notes} />
          </List.Item>
        )}
      />
    )
  }

  const columns = () => {
    const __columns = [
      { title: '#', dataIndex: 'display_id', key: 'order', width: 80 },
      { title: 'Date', dataIndex: 'date', key: 'date', width: 90 },
      {
        title: 'Vendor',
        dataIndex: 'vendor_name',
        key: 'vendor_name'
      },
      { title: 'Type', dataIndex: 'lqa_type', key: 'lqa_type' },
      {
        title: 'Scorecard',
        dataIndex: 'scorecard',
        key: 'scorecard',
        render: (resource, record) => {
          const onUploadScorecard = (form) => props.uploadScorecard({ qaId: record.id, form })
          if (resource) {
            return (
              <Space split={<Divider type='vertical' />}>
                <Button
                  size='small'
                  type='link'
                  onClick={() => props.downloadScorecard({ qaId: record.id, name: resource.name})}
                >
                  Scorecard
                </Button>
                <Popconfirm
                  title='Are you sure?'
                  onConfirm={() => props.removeScorecard(record.id)}
                  okText='Yes'
                  cancelText='No'
                  disabled={props.isModalActive || props.actionLoading}
                >
                  <Button
                    size='small'
                    type='link'
                    disabled={props.isModalActive || props.actionLoading}
                  >
                    Delete
                  </Button>
                </Popconfirm>
              </Space>
            )
          }

          return (
            <UploadButton
              key='receipt-upload'
              modalLabel='Scorecard'
              buttonLabel='Upload scorecard'
              buttonType='link'
              onUpload={onUploadScorecard}
            />
          )
        }
      },
      {
        title: 'Score',
        dataIndex: 'score',
        key: 'score'
      }
    ]

    if (props.allowEdit) {
      __columns.push({
        title: 'Action',
        key: 'operation',
        align: 'center',
        width: 200,
        render: (record) => {
          return (
            <Space split={<Divider type='vertical' />}>
              <Button
                size='small'
                type='link'
                block
                onClick={() => props.onModalEdit(record)}
                disabled={props.isModalActive || props.actionLoading}
              >
                Edit
              </Button>
              <Button
                size='small'
                type='link'
                block
                onClick={() => props.onModalComment(record)}
                disabled={props.isModalActive || props.actionLoading}
              >
                Comment
              </Button>
              <Popconfirm
                title='Are you sure?'
                onConfirm={() => props.removeLqa(record.id)}
                okText='Yes'
                cancelText='No'
                disabled={props.isModalActive || props.actionLoading}
              >
                <Button size='small' type='link' disabled={props.isModalActive || props.actionLoading}>
                  Delete
                </Button>
              </Popconfirm>
            </Space>
          )
        }
      })
    }

    return __columns
  }

  return (
    <Table
      size='small'
      className='components-table-demo-nested'
      columns={columns()}
      expandable={{
        expandedRowRender: (record) => expandedRowRender(record),
        rowExpandable: (record) => (record.timeline || []).length > 0
      }}
      dataSource={props.lqas || []}
      rowKey={(row) => row.id}
      pagination={false}
    />
  )
}

export default Tasks
